import { z } from 'zod';
import { englishIqKindV2Schema, englishIqSkillV2Schema } from '../schemasV2';

export const startEnglishIqSessionV2RequestSchema = z
  .object({
    kind: englishIqKindV2Schema,
    locale: z.string().min(2).max(16).optional(),
    skill: englishIqSkillV2Schema.optional(),
    sourceShareId: z.string().min(6).max(64).optional(),
    turnstileToken: z.string().min(1).optional(),
    visitorId: z.string().min(1).max(128).optional(),
  })
  .superRefine((value, context) => {
    if (value.kind === 'skill_check' && !value.skill) {
      context.addIssue({ code: 'custom', message: 'skill is required for a skill check' });
    }
    if (value.kind === 'benchmark' && value.skill) {
      context.addIssue({ code: 'custom', message: 'benchmark cannot select one skill' });
    }
  });

export type IStartEnglishIqSessionV2Request = z.infer<typeof startEnglishIqSessionV2RequestSchema>;
